<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <div v-if="isLocked" class="alert alert-warning">
     لا يمكن تعديل الطلبات المكتملة او الملغية بإستثناء صيانة بيوت الله والصيانة العامة
    </div>

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button class="nav-link active" id="order-tab" data-bs-toggle="tab" data-bs-target="#order-tab-pane" type="button" role="tab" aria-controls="order-tab-pane" aria-selected="true">بيانات الطلب</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="providers-tab" data-bs-toggle="tab" data-bs-target="#providers-tab-pane" type="button" role="tab" aria-controls="providers-tab-pane" aria-selected="false">المزودين المقترحين</button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade p-3 show active" id="order-tab-pane" role="tabpanel" aria-labelledby="order-tab" tabindex="0">
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">نوع الطلب:</label>
                    <div class="d-inline-block ms-2">{{ orderTypes[dataRow.orderType] }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الخدمة:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.MaintenanceIssue)? dataRow.MaintenanceIssue.name : 'غير معروف' }}</div>
                  </div>
                </div>

                <!-- Requester Type & Coupon Info -->
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">نوع مقدم الطلب:</label>
                    <div class="d-inline-block ms-2">
                      <span v-if="dataRow.orderType === 'global'" class="badge bg-info">عميل عادي</span>
                      <span v-else-if="dataRow.orderType === 'mosque'" class="badge bg-secondary">جهة عامة</span>
                      <span v-else-if="dataRow.mobile || dataRow.name" class="badge bg-primary">
                        {{ dataRow.name || 'مستأجر / مالك' }}
                      </span>
                      <span v-else-if="dataRow.User && dataRow.User.id" class="badge bg-success">عميل مسجل</span>
                      <span v-else class="badge bg-secondary">غير معروف</span>
                    </div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">كوبون الخصم:</label>
                    <div class="d-inline-block ms-2">
                      <span v-if="dataRow.couponId && dataRow.couponAccepted" class="badge bg-success">
                        <i class="fa-solid fa-tag me-1"></i>
                        مُطبَّق — 
                        <span v-if="dataRow.couponType === 'percentage'">{{ dataRow.couponAmount }}٪ خصم</span>
                        <span v-else>{{ dataRow.couponAmount }} ريال خصم</span>
                      </span>
                      <span v-else-if="dataRow.couponId && !dataRow.couponAccepted" class="badge bg-warning text-dark">
                        <i class="fa-solid fa-tag me-1"></i>كوبون (لم يُقبل)
                      </span>
                      <span v-else class="badge bg-light text-muted">لا يوجد كوبون</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">اسم العميل:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.User)? dataRow.User.name : 'غير معروف' }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">جوال العميل:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.User)? dataRow.User.mobile : 'غير معروف' }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label class="form-label" for="">المزود:</label>
                    <input type="text" class="form-control" placeholder="جوال المزود" @keyup="getProviderData()" v-model="providerMobile">
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <loader v-if="providerLoader" />
                    <div v-if="providerName">
                      <label class="form-label" for="">اسم المزود:</label>
                      <div>{{ providerName }}</div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">المشكلة:</label>
                    <div>{{ dataRow.title }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">المشكلة (مترجمة):</label>
                    <div>{{ dataRow.titleEn }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وصف المشكلة:</label>
                    <div>{{ dataRow.description }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وصف المشكلة (مترجمة):</label>
                    <div>{{ dataRow.descriptionEn }}</div>
                  </div>
                </div>

                <div class="row">
                  <div v-if="dataRow.image" class="col-12 col-sm-6 text-center mb-3">
                    <video v-if="isIssueVideo" :src="MEDIA_URL+dataRow.image" class="img-thumbnail img-fluid w-100" style="max-height: 350px;" controls preload="metadata" playsinline aria-label="فيديو المشكلة">متصفحك لا يدعم تشغيل الفيديو.</video>
                    <img v-else :src="MEDIA_URL+dataRow.image" class="img-thumbnail img-fluid" alt="صورة المشكلة">
                    <a v-if="isIssueVideo" :href="MEDIA_URL+dataRow.image" class="d-block mt-2" target="_blank" rel="noopener noreferrer">فتح الفيديو</a>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div ref="orderMap" style="width: 100%; height: 350px;"></div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">المنطقة:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.Region)? dataRow.Region.name : 'غير معروف' }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">المدينة:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.City)? dataRow.City.name : 'غير معروف' }}</div>
                  </div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">الحي:</label>
                  <div class="d-inline-block ms-2">
                    <span v-if="dataRow.Neighborhood">{{ dataRow.Neighborhood.name }}</span>
                    <span v-else-if="dataRow.neighborhoodId" class="text-muted">#{{ dataRow.neighborhoodId }}</span>
                    <span v-else class="text-muted">غير معروف</span>
                  </div>
                </div>
                <div class="col-12 col-sm-6 mb-3">
                  <label for="" class="form-label">مصدر الطلب:</label>
                  <div class="d-inline-block ms-2">
                    <span v-if="dataRow.requestSource === 'admin'" class="badge bg-secondary">لوحة التحكم</span>
                    <span v-else-if="dataRow.requestSource === 'ios'" class="badge bg-primary">Iphone</span>
                    <span v-else-if="dataRow.requestSource === 'android'" class="badge bg-primary">Android</span>
                    <span v-else-if="dataRow.requestSource === 'website'" class="badge bg-info">الموقع الإلكتروني</span>
                    <span v-else-if="dataRow.requestSource" class="badge bg-light text-dark">{{ dataRow.requestSource }}</span>
                    <span v-else class="text-muted">غير محدد</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت تعيين المزود:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.assignTime) }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت وصول المزود:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.arriveTime) }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت إتمام الطلب:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.doneTime) }}</div>
                    <div v-if="dataRow.doneNotice" class="d-inline-block ms-2">{{ dataRow.doneNotice }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">وقت إلغاء الطلب:</label>
                    <div v-if="dataRow.Provider" class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.cancelTime) }}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">مبلغ جدية الطلب:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.deposit }} ريال</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الإكرامية:</label>
                    <input type="number" class="form-control" v-model="tip" >
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">سعر شغل اليد:</label>
                    <input type="number" class="form-control" v-model="price" >
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">سعر قطع الغيار:</label>
                    <input type="number" class="form-control" v-model="partsPrice" >
                  </div>
                </div>
                <div
                  v-if="dataRow.partsInvoice && dataRow.partsInvoice.length"
                  class="row"
                  >
                  <div class="col-12 mb-3">
                    <label class="form-label">
                      فواتير قطع الغيار:
                    </label>
                    <div class="row mt-2">
                      <div
                        v-for="(invoice, index) in dataRow.partsInvoice"
                        :key="index"
                        class="col-12 col-md-6 col-lg-4 mb-3"
                      >
                        <div class="card p-2 h-100">
                          <img
                            v-if="isImage(invoice)"
                            :src="MEDIA_URL + invoice"
                            class="img-fluid rounded border"
                            style="max-height:250px; object-fit:contain;"
                          />
                          <iframe
                            v-else
                            :src="MEDIA_URL + invoice"
                            width="100%"
                            height="250"
                            style="border:1px solid #ddd; border-radius:8px;"
                          ></iframe>
                          <div class="mt-2 text-center">
                            <a
                              :href="MEDIA_URL + invoice"
                              target="_blank"
                              class="btn btn-outline-primary btn-sm"
                            >
                              <i class="fa-solid fa-eye me-1"></i>
                              عرض الملف
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">قيمة عمولة المحيسني العقارية:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.commissionAmount }} ريال</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">نسبة عمولة المحيسني العقارية:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.commissionPercentage }}٪</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">طريقة الدفع:</label>
                    <select v-model="paymentGate" class="form-control">
                      <option value="online">دفع إلكتروني</option>
                      <option value="wallet">محفظة</option>
                      <option value="applepay">ابل باي</option>
                      <option value="cash">كاش</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة الطلب:</label>
                    <select ref="statusSelect" v-model="status" class="form-control">
                      <!-- <option v-for="(val, key) in orderStatus" :value="key" :key="key">{{ val }}</option> -->
                      <optgroup label="الإدارة">
                        <option value="new">{{ orderStatus['new'] }}</option>
                        <option value="under_review">{{ orderStatus['under_review'] }}</option>
                        <option value="done">{{ orderStatus['done'] }}</option>
                        <option value="admin_done">{{ orderStatus['admin_done'] }}</option>
                      </optgroup>
                      <optgroup label="العميل">
                        <option value="client_canceled">{{ orderStatus['client_canceled'] }}</option>
                        <option value="waiting_deposit">{{ orderStatus['waiting_deposit'] }}</option>
                        <option value="deposit_issue">{{ orderStatus['deposit_issue'] }}</option>
                        <option value="waiting_payment">{{ orderStatus['waiting_payment'] }}</option>
                        <option value="payment_issue">{{ orderStatus['payment_issue'] }}</option>
                        <option value="scheduled">{{ orderStatus['scheduled'] }}</option>
                      </optgroup>
                      <optgroup label="المزود">
                        <option value="assigned">{{ orderStatus['assigned'] }}</option>
                        <option value="arrived">{{ orderStatus['arrived'] }}</option>
                        <option value="hold">{{ orderStatus['hold'] }}</option>
                        <option value="provier_canceled">{{ orderStatus['provier_canceled'] }}</option>
                      </optgroup>
                    </select>
                    <div v-if="status == 'admin_done'" class="alert alert-danger mt-3">في حالة إغلاق الطلب إدارياً لن يتم معالجته مادياً بشكل آلي ويرجى إتمام المعالجة المالية يديوياً</div>
                  </div>
                </div>

                <div class="row">
                  <!-- <div class="col-12 col-sm-6 mb-3">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :value="true" v-model="isPaid" id="isPaid">
                      <label class="form-check-label" for="isPaid">
                        تم سداد قيمة الطلب بنجاح
                      </label>
                    </div>
                  </div> -->
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">حالة السداد:</label>
                    <div>{{ (isPaid)? 'تم سداد قيمة الطلب بنجاح' : 'طلب غير مدفوع' }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">سبب الإلغاء - <small>في حالة كان الطلب لاغي</small> :</label>
                    <select ref="cancelReasonSelect" v-model="cancelReason" class="form-control">
                      <option :value="null">غير لاغي</option>
                      <optgroup label="إلغاء من طرف العميل">
                        <option v-for="(val, key) in orderCancelClient" :value="key" :key="key">{{ val }}</option>
                      </optgroup>
                      <optgroup label="إلغاء من طرف المزود">
                        <option v-for="(val, key) in orderCancelProvider" :value="key" :key="key">{{ val }}</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تاريخ الطلب:</label>
                    <div class="date-format">{{ formatDate(dataRow.createdAt) }}</div>
                  </div>
                  <div v-if="dataRow.paymentId" class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">بيانات السداد:</label>
                    <div>
                      <router-link :to="`/payments/update/${dataRow.paymentId}`">عرض بيانات السداد</router-link>
                    </div>
                  </div>
                </div>

                <div v-if="dataRow.holdTime" class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تاريخ الإقاف المؤقت:</label>
                    <div class="d-inline-block ms-2 date-format">{{ formatDate(dataRow.holdTime) }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">سبب التوقف المؤقت:</label>
                    <div class="d-inline-block ms-2">{{ (dataRow.holdReason)? orderHoldReasons[dataRow.holdReason] : 'غير معروف' }}</div>
                    <div class="d-inline-block ms-2">{{ dataRow.holdDetails }}</div>
                  </div>
                </div>

                <div v-if="dataRow.imageAfter || dataRow.imageBefore" class="row">
                  <div v-if="dataRow.imageBefore" class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الصورة قبل الإصلاح:</label>
                    <img :src="MEDIA_URL+dataRow.imageBefore" class="img-thumbnail img-fluid" alt="">
                  </div>
                  <div v-if="dataRow.imageAfter" class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">الصورة بعد الإصلاح:</label>
                    <img :src="MEDIA_URL+dataRow.imageAfter" class="img-thumbnail img-fluid" alt="">
                  </div>
                </div>

                <div v-if="dataRow" class="border rounded p-3 mb-3">
                  <h6 class="mb-3">إرفاق صور وفواتير الصيانة</h6>
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="imageBeforeUpload" class="form-label">صورة قبل الصيانة</label>
                      <input id="imageBeforeUpload" ref="imageBeforeUpload" type="file" class="form-control" accept="image/png,image/jpeg,image/webp" @change="imageBeforeFile = $event.target.files[0] || null">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label for="imageAfterUpload" class="form-label">صورة بعد الصيانة</label>
                      <input id="imageAfterUpload" ref="imageAfterUpload" type="file" class="form-control" accept="image/png,image/jpeg,image/webp" @change="imageAfterFile = $event.target.files[0] || null">
                    </div>
                    <div class="col-12 mb-3">
                      <label for="partsInvoiceUpload" class="form-label">فواتير قطع الغيار (صور أو PDF)</label>
                      <input id="partsInvoiceUpload" ref="partsInvoiceUpload" type="file" class="form-control" accept="image/png,image/jpeg,image/webp,application/pdf" multiple @change="invoiceFiles = Array.from($event.target.files)">
                      <small class="text-muted">تُضاف الفواتير الجديدة إلى الفواتير الموجودة. الصور الجديدة تحل محل الصورة السابقة.</small>
                    </div>
                  </div>
                  <button type="button" class="btn btn-outline-primary" :disabled="attachmentsLoading" @click="uploadAttachments">
                    {{ attachmentsLoading ? 'جارٍ الرفع...' : 'رفع المرفقات' }}
                  </button>
                </div>

                <div class="row">
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">تقييم العميل:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.rate }}</div>
                  </div>
                  <div class="col-12 col-sm-6 mb-3">
                    <label for="" class="form-label">ملاحظات العميل:</label>
                    <div class="d-inline-block ms-2">{{ dataRow.rateNote }}</div>
                  </div>
                </div>
                <div class="row">
                <div class="col-12 col-sm-6 mb-3">
                  <label class="form-label">طلب مجدول:</label>
                  <div class="form-check form-switch mt-1">
                    <input class="form-check-input" type="checkbox" id="isSchedule" v-model="isSchedule">
                    <label class="form-check-label" for="isSchedule">{{ isSchedule ? 'نعم' : 'لا' }}</label>
                  </div>
                </div>
                <div class="col-12 col-sm-6 mb-3" v-if="isSchedule">
                  <label class="form-label">تاريخ الجدولة:</label>
                  <input type="date" class="form-control mb-2" v-model="scheduleDate" :min="todayDate">
                  <label class="form-label">وقت الجدولة:</label>
                  <select class="form-control" v-model="scheduleTime">
                    <option value="">-- اختر الوقت --</option>
                    <option v-for="slot in timeSlots" :key="slot.value" :value="slot.value">{{ slot.label }}</option>                  </select>
                </div>
              </div>  
              </div>
              <div class="tab-pane fade p-3" id="providers-tab-pane" role="tabpanel" aria-labelledby="providers-tab" tabindex="0">
                <div class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>الجوال</th>
                            <th>الحالة</th>
                            <th>سبب الرفض</th>
                            <th>وقت الارسال</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="acceptance in dataRow.ProvidersOrdersAcceptances" :key="acceptance.id">
                            <td>{{ acceptance.id }}</td>
                            <td>{{ (acceptance.Provider)? acceptance.Provider.name : 'غير معروف' }}</td>
                            <td>{{ (acceptance.Provider)? acceptance.Provider.mobile : 'غير معروف' }}</td>
                            <td>{{ providerAcceptanceStatus[acceptance.status] }}</td>
                            <td>{{ (acceptance.rejectReason)? orderRejectReasons[acceptance.rejectReason] : '' }}</td>
                            <td class="date-format">{{ formatDate(acceptance.createdAt) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسال</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { toast, formatDate, isImage, timeSlots } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'OrdersForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    orderStatus: {
      type: Object,
      default: null,
    },
    orderCancelAdmin: {
      type: Object,
      default: null,
    },
    orderTypes: {
      type: Object,
      default: null,
    },
    orderRejectReasons: {
      type: Object,
      default: null,
    },
    orderHoldReasons: {
      type: Object,
      default: null,
    },
    providerAcceptanceStatus: {
      type: Object,
      default: null,
    },
    orderCancelClient: {
      type: Object,
      default: {},
    },
    orderCancelProvider: {
      type: Object,
      default: {},
    },
  },
  data(){
    return {
      formLoader: false,
      providerLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      map: null,
      marker: null,
      providerMobile: null,
      providerName: null,
      providerId: null,
      price: 0,
      partsPrice: 0,
      tip: 0,
      status: null,
      cancelReason: null,
      paymentGate: null,
      isPaid: false,
      adminNotice: null,
      isSchedule: false,
      scheduleDate: null,
      scheduleTime: '',
      timeSlots: timeSlots(),
      attachmentsLoading: false,
      imageBeforeFile: null,
      imageAfterFile: null,
      invoiceFiles: [],
    }
  },
  computed:{
    ...mapGetters(['MEDIA_URL', 'GOOGLE_MAP_API']),
    isIssueVideo() {
      const image = this.dataRow && this.dataRow.image;
      return !!image && (this.dataRow.imageFileType === 'video' || /\.(mp4|mov)(?:[?#]|$)/i.test(image));
    },
    
    isLocked() {
      if (!this.dataRow) return false;

      return (
        this.dataRow.status === 'done' ||
        this.dataRow.status === 'client_canceled' ||
        this.dataRow.status === 'provier_canceled'
      );
    },
    todayDate() {
      return new Date().toISOString().split('T')[0];
    },
  },
  methods: {
    formatDate,
    isImage,
    uploadAttachments(){
      if (!this.dataRow || this.attachmentsLoading) return;
      if (!this.imageBeforeFile && !this.imageAfterFile && !this.invoiceFiles.length) {
        this.hasError = true;
        this.message = 'اختر صورة أو فاتورة للرفع';
        return;
      }
      const formData = new FormData();
      if (this.imageBeforeFile) formData.append('imageBefore', this.imageBeforeFile);
      if (this.imageAfterFile) formData.append('imageAfter', this.imageAfterFile);
      this.invoiceFiles.forEach(file => formData.append('partsInvoice', file));
      this.attachmentsLoading = true;
      this.hasError = false;
      this.hasSucess = false;
      this.$http.post(`/api/admin/orders/${this.dataRow.id}/attachments`, formData).then(({data}) => {
        this.$emit('attachments-updated', data.row);
        this.imageBeforeFile = null;
        this.imageAfterFile = null;
        this.invoiceFiles = [];
        for (const field of ['imageBeforeUpload', 'imageAfterUpload', 'partsInvoiceUpload']) {
          if (this.$refs[field]) this.$refs[field].value = '';
        }
        this.message = 'تم رفع المرفقات بنجاح';
        this.hasSucess = true;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      }).finally(() => {
        this.attachmentsLoading = false;
      });
    },
    subimtData(){
      
      this.hasError = false;
      this.hasSucess = false;
      
      if (
        this.dataRow &&
        !['mosque', 'global'].includes(this.dataRow.orderType) &&
        ['done', 'client_canceled', 'provier_canceled']
          .includes(this.dataRow.status)
      ) {
        this.hasError = true;
        this.message = 'لا يمكن تعديل هذا الطلب';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      if (
        (this.status === 'client_canceled' || 
        this.status === 'provier_canceled') &&
        !this.cancelReason
      ) {
        this.hasError = true;
        this.message = 'يجب اختيار سبب الإلغاء';
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if (this.isSchedule) {
        if (!this.scheduleDate || !this.scheduleTime) {
          this.hasError = true;
          this.message = 'يجب تحديد تاريخ ووقت الجدولة';
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        const d = new Date(`${this.scheduleDate}T${this.scheduleTime}:00`);
        if (d <= new Date()) {
          this.hasError = true;
          this.message = 'وقت الجدولة يجب أن يكون في المستقبل';
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
      }

  const oldProviderId =
    this.dataRow?.providerId || this.dataRow?.Provider?.id || null;

  if (this.providerId && this.providerId !== oldProviderId) {
    this.status = 'assigned';
  }
  
  this.formLoader = true;

      const payload = {
        providerId: this.providerId,
        price: this.price,
        partsPrice: this.partsPrice,
        tip: this.tip,
        status: this.status,
        cancelReason: this.cancelReason,
        paymentGate: this.paymentGate,
        // isPaid: this.isPaid,
        adminNotice: this.adminNotice, 
        isSchedule: this.isSchedule,
        scheduleDate: this.isSchedule && this.scheduleDate && this.scheduleTime
        ? `${this.scheduleDate}T${this.scheduleTime}:00`
        : null,
      }
      
      let api = null;

      if(this.dataRow)
        api = this.$http.put(`/api/admin/orders/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/orders/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/orders').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    setImage(files){
      this.image = files[0];
    },
    getProviderData(){
      this.providerId = null;
      this.providerName = null;
      if(this.providerMobile && this.providerMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.providerLoader = true;
        // this.providerId = null;
        // this.providerName = null;
        this.$http.post('/api/admin/orders/getProvider', {
          mobile: this.providerMobile.trim(),
        }).then(({data}) => {
          this.providerId = data.provider.id;
          this.providerName = data.provider.name;
          this.providerLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.providerLoader = false;
          // window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    // google map 
    initMap(){
      if (!this.$refs.orderMap) {
        setTimeout(() => this.initMap(), 200);
        return;
      }
      if (!window.google) {
        console.error("Google Maps API is not loaded.");
        return;
      }

      // Initialize Map
      this.map = new google.maps.Map(this.$refs.orderMap, {
        center: { lat: parseFloat(this.dataRow.latitude) ?? 24.7136, lng: parseFloat(this.dataRow.longitude) ?? 46.6753 },
        zoom: 8,
      });

      // Create a Marker
      this.marker = new google.maps.Marker({
        position: { lat: parseFloat(this.dataRow.latitude) ?? 24.7136, lng: parseFloat(this.dataRow.longitude) ?? 46.6753 },
        map: this.map,
        draggable: false, // Allow dragging the marker
      });
    },
    initialGoogleMap(){
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${this.GOOGLE_MAP_API}&loading=async&libraries=places&callback=initMap`;
        script.async = true;
        document.head.appendChild(script);
        window.initMap = this.initMap;
      } else {
        this.initMap();
      }
    },
    applySelect2Status(){
      if(!this.$refs.statusSelect){
        setTimeout(() => this.applySelect2Status(), 200);
        return;
      }
      const vm = this;
      const $el = $(this.$refs.statusSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.statusSelect2');
        $el.select2('destroy');
      }
      $el.select2({
        width: '100%'
      });
      $el.val(this.status).trigger('change.select2');
      $el.on('change.statusSelect2', function(){
        vm.status = $(this).val() || null;
      });
    },
    applySelect2CancelReason(){
      if(!this.$refs.cancelReasonSelect){
        setTimeout(() => this.applySelect2CancelReason(), 200);
        return;
      }
      const vm = this;
      const $el = $(this.$refs.cancelReasonSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.cancelReasonSelect2');
        $el.select2('destroy');
      }
      $el.select2({
        width: '100%'
      });
      $el.val(this.cancelReason).trigger('change.select2');
      $el.on('change.cancelReasonSelect2', function(){
        vm.cancelReason = $(this).val() || null;
      });
    },
  },
  created(){
    if(this.dataRow){
      this.providerId = this.dataRow.providerId;
      this.price = this.dataRow.price;
      this.partsPrice = this.dataRow.partsPrice;
      this.tip = this.dataRow.tip;
      this.status = this.dataRow.status;
      this.cancelReason = this.dataRow.cancelReason;
      this.paymentGate = this.dataRow.paymentGate;
      this.isPaid = this.dataRow.isPaid;
      this.adminNotice = this.dataRow.adminNotice;
      this.isSchedule = this.dataRow.isSchedule || false;
      if (this.dataRow.scheduleDate) {
        const d = new Date(this.dataRow.scheduleDate);
        this.scheduleDate = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = d.getMinutes() < 30 ? '00' : '30';
        this.scheduleTime = `${hh}:${mm}`;
      }
      if(this.dataRow.Provider){
        this.providerMobile = this.dataRow.Provider.mobile;
        this.providerName = this.dataRow.Provider.name;
      }
      this.initialGoogleMap();
    }
    this.applySelect2Status();      
    this.applySelect2CancelReason(); 
  },
  watch: {
    orderStatus(){
      this.$nextTick(() => this.applySelect2Status());
    },
    orderCancelClient(){
      this.$nextTick(() => this.applySelect2CancelReason());
    },
    orderCancelProvider(){
      this.$nextTick(() => this.applySelect2CancelReason());
    },
  },
}
</script>